import { Link } from "react-router-dom";
import { PrimaryButton } from "@/components/shared/PrimaryButton";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-navy text-white flex flex-col items-center justify-center px-6 text-center grid-lines-dark">
      <p className="font-head font-extrabold text-cyan text-7xl md:text-9xl">404</p>
      <h1 className="font-head font-bold text-2xl md:text-3xl mt-4">Sayfa bulunamadı</h1>
      <p className="text-silver/70 mt-3 max-w-md">Aradığınız sayfa taşınmış veya mevcut olmayabilir.</p>
      <div className="mt-8"><PrimaryButton to="/">ANA SAYFAYA DÖN</PrimaryButton></div>
    </div>
  );
}
